import {USERS_AUTOCOMPLETE_LOADING, USERS_AUTOCOMPLETE_UPDATE} from "../actions/userAutocompleteActions";

const INITIAL_STATE = {
  users: {},
  loading: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS_AUTOCOMPLETE_UPDATE:
      const users = {...state.users, [action.id]: action.payload.data.map((user) => ({...user, full_name: `${user.name} ${user.last_name}`}) )};
      return {
        ...state,
        users: users,
      };
    case USERS_AUTOCOMPLETE_LOADING:
      const loading = {...state.loading, [action.id]: action.payload};
      return {
        ...state,
        loading: loading,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/users/reducers/UserAutocompleteReducer.js